// ========================================
// 🏷️ ACTIONS CONSTANTS
// ========================================
export const GET_ALL_EMPLOIS_REQUEST = 'GET_ALL_EMPLOIS_REQUEST';
export const GET_ALL_EMPLOIS_SUCCESS = 'GET_ALL_EMPLOIS_SUCCESS';
export const GET_ALL_EMPLOIS_FAIL = 'GET_ALL_EMPLOIS_FAIL';

export const GET_EMPLOI_REQUEST = 'GET_EMPLOI_REQUEST';
export const GET_EMPLOI_SUCCESS = 'GET_EMPLOI_SUCCESS';
export const GET_EMPLOI_FAIL = 'GET_EMPLOI_FAIL';

export const CREATE_EMPLOI_REQUEST = 'CREATE_EMPLOI_REQUEST';
export const CREATE_EMPLOI_SUCCESS = 'CREATE_EMPLOI_SUCCESS';
export const CREATE_EMPLOI_FAIL = 'CREATE_EMPLOI_FAIL';

export const UPDATE_EMPLOI_REQUEST = 'UPDATE_EMPLOI_REQUEST';
export const UPDATE_EMPLOI_SUCCESS = 'UPDATE_EMPLOI_SUCCESS';
export const UPDATE_EMPLOI_FAIL = 'UPDATE_EMPLOI_FAIL';

export const DELETE_EMPLOI_REQUEST = 'DELETE_EMPLOI_REQUEST';
export const DELETE_EMPLOI_SUCCESS = 'DELETE_EMPLOI_SUCCESS';
export const DELETE_EMPLOI_FAIL = 'DELETE_EMPLOI_FAIL';

// ========================================
// 🎬 ACTION CREATORS
// ========================================

export const getAllEmploisRequest = () => ({
    type: GET_ALL_EMPLOIS_REQUEST
});

export const getAllEmploisSuccess = (emplois) => ({
    type: GET_ALL_EMPLOIS_SUCCESS,
    payload: emplois
});

export const getAllEmploisFail = (error) => ({
    type: GET_ALL_EMPLOIS_FAIL,
    error
});

export const getEmploiRequest = (id) => ({
    type: GET_EMPLOI_REQUEST,
    payload: id
});

export const getEmploiSuccess = (emploi) => ({
    type: GET_EMPLOI_SUCCESS,
    payload: emploi
});

export const getEmploiFail = (error) => ({
    type: GET_EMPLOI_FAIL,
    error
});

export const createEmploiRequest = (emploi, callback) => ({
    type: CREATE_EMPLOI_REQUEST,
    payload: emploi,
    callback
});

export const createEmploiSuccess = (emploi) => ({
    type: CREATE_EMPLOI_SUCCESS,
    payload: emploi
});

export const createEmploiFail = (error) => ({
    type: CREATE_EMPLOI_FAIL,
    error
});

export const updateEmploiRequest = (id, emploi, callback) => ({
    type: UPDATE_EMPLOI_REQUEST,
    payload: { id, emploi },
    callback
});

export const updateEmploiSuccess = (emploi) => ({
    type: UPDATE_EMPLOI_SUCCESS,
    payload: emploi
});

export const updateEmploiFail = (error) => ({
    type: UPDATE_EMPLOI_FAIL,
    error
});

export const deleteEmploiRequest = (id) => ({
    type: DELETE_EMPLOI_REQUEST,
    payload: id
});

export const deleteEmploiSuccess = (id) => ({
    type: DELETE_EMPLOI_SUCCESS,
    payload: id
});

export const deleteEmploiFail = (error) => ({
    type: DELETE_EMPLOI_FAIL,
    error
});
